import { ApiKeyListItem } from 'types/apiKeys';

import { ApiKeyTableRow } from './types';

export const transformApiKeysDataToTableFormat = (keys?: ApiKeyListItem[]): ApiKeyTableRow[] =>
  (keys || []).map((key) => ({
    id: key.uuid,
    uuid: key.uuid,
    name: key.name || '',
    publicKey: key.publicKey,
    secretKeyTruncated: key.secretKeyTruncated,
    createdAt: key.createdAt,
    createdBy: key.createdBy?.username || '',
    lastUsedAt: key.lastUsedAt,
    whitelist: formatWhitelistedIps(key.whitelistedIps),
    whitelistedIps: key.whitelistedIps || [],
  }));

export const formatWhitelistedIps = (whitelistedIps?: string[]): string => {
  if (!whitelistedIps || whitelistedIps.length === 0) {
    return 'All IPs';
  }

  return whitelistedIps.join(', ');
};

export const parseWhitelistInput = (value: string): string[] =>
  value
    .split(/[,\n]/)
    .map((entry) => entry.trim())
    .filter(Boolean);
